import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogin, userLogout } from "../../actions/user";
import {
  // currentWindowPath,
  getRedirectPath,
} from "../../utils/comman";
import LoginImg from "../../assets/img/login-img.png";
import Button from "../../components/Button/Button";

const LoginForm = () => {
  const [form] = Form.useForm();
  const dispatch: any = useDispatch();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    document.title = "Helios";
  }, []);

  const onFinish = async (values: any) => {
    const payload = {
      email: values?.email,
      password: values?.password,
    };

    dispatch(
      userLogin(payload, (resp: any) => {
        if (resp?.status === 200) {
          // Handle successful login
        } else {
          dispatch(
            userLogout(() => {
              window.location.href = getRedirectPath();
            })
          );
        }
      })
    );
  };

  return (
    <div className="authforms flex items-center justify-center p-40 2xl:pt-[120px] 2xl:pt[150px]">
      <div className="authHeadings">
        <img
          src={LoginImg}
          alt="login-image"
          className=" max-w-[250px] 2xl:max-w-full mx-auto mb-[20px] 2xl:mb-[50px]"
        />
        <div className="textAuthHeading text-center max-w-[350px] mx-auto">
          <h3 className="text-white text-[30px] mb-[10px] font-medium">
            {/* {findUser ? `${findUser} LOGIN` : "USER LOGIN"} */}
            LOGIN
          </h3>

          <p className="text-white text-[18px] font-normal mb-[20px]">
            Access to this system can only be granted by HELIOS user.
            {/* {findUser ? lowerCase(findUser) : "user"}. */}
          </p>

          {/* Ant Design Form */}
          <Form
            form={form}
            name="login_form"
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ remember: true }}
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Invalid email format!" },
              ]}
            >
              <Input
                placeholder="Email"
                className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] 2xl:p-[20px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff]"
              />
            </Form.Item>

            <Form.Item name="password" rules={[{ required: true }]}>
              <div className="relative">
                <Input
                  type={visible ? "text" : "password"}
                  placeholder="Password"
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[0px] p-[15px] 2xl:p-[20px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] text-white"
                />
                <span
                  className="hide-show-col absolute 2xl:top-[22px] top-[18px] right-5 text-[#48bb89] text-sm cursor-pointer"
                  onClick={() => setVisible(!visible)}
                >
                  {visible ? "Hide" : "Show"}
                </span>
              </div>
            </Form.Item>

            <Link
              to="/forgot-password"
              className="text-[#48ba89] 2xl:mt-[10px] mb-[20px] 2xl:mb-[30px] block text-sm text-right"
            >
              Recovery Password?
            </Link>

            <Form.Item>
              <Button buttonText="LOGIN" width="100%" padding="p-[20px]" />
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
